
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalogo-de-accesorios",
      function () {
        return require("private-next-pages/catalogo-de-accesorios.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalogo-de-accesorios"])
      });
    }
  